import React from "react"
import styled, { withTheme } from "styled-components"
import { useTheme } from "../../context/ThemeContext"
import { darkModeToggleTheme, whiteTheme } from "../../theme"

// kudos to narative.co
// https://github.com/narative/gatsby-theme-novela/blob/fb38329e17595df6e846be1d33517ff6125cde4e/src/components/Navigation/Navigation.Header.tsx
// adaptation for js

const IconWrapper = styled.button`
  padding: 0;
  appearance: none;
  align-items: center;
  background: transparent;
  border-radius: 5px;
  border: 0;
  cursor: pointer;
  display: inline-flex;
  height: 40px;
  justify-content: center;
  margin-right: -11px;
  opacity: 0.75;
  overflow: hidden;
  position: relative;
  transform: scale(0.75);
  transition: opacity 0.3s ease;
  vertical-align: middle;
  width: 40px;
  &:hover {
    opacity: 1;
  }
`

const MoonOrSun = styled.div`
  border: ${p => (p.isDark ? `4px` : `2px`)} solid ${darkModeToggleTheme};
  background: ${darkModeToggleTheme};
  border-radius: 50%;
  height: 24px;
  overflow: ${p => (p.isDark ? `visible` : `hidden`)};
  position: relative;
  transform: scale(${p => (p.isDark ? 0.55 : 1)});
  transition: all 0.45s ease;
  width: 24px;
  &::before {
    border-radius: 50%;
    border: 2px solid ${darkModeToggleTheme};
    content: "";
    height: 24px;
    opacity: ${p => (p.isDark ? 0 : 1)};
    position: absolute;
    right: -9px;
    top: -9px;
    transform: translate(${p => (p.isDark ? `14px, -14px` : `0, 0`)});
    transition: transform 0.45s ease;
    width: 24px;
  }
  &::after {
    border-radius: 50%;
    box-shadow: 0 -23px 0 ${darkModeToggleTheme},
      0 23px 0 ${darkModeToggleTheme}, 23px 0 0 ${darkModeToggleTheme},
      -23px 0 0 ${darkModeToggleTheme}, 15px 15px 0 ${darkModeToggleTheme},
      -15px 15px 0 ${darkModeToggleTheme}, 15px -15px 0 ${darkModeToggleTheme},
      -15px -15px 0 ${darkModeToggleTheme};
    content: "";
    height: 8px;
    left: 50%;
    margin: -4px 0 0 -4px;
    position: absolute;
    top: 50%;
    width: 8px;
    transform: scale(${p => (p.isDark ? 1 : 0)});
    transition: all 0.35s ease;
    ${({ theme }) => theme.tablet`
     transform: scale(${p => (p.isDark ? 0.92 : 0)});
  `}
  }
`

const MoonMask = styled.div`
  background: ${whiteTheme};
  border-radius: 50%;
  border: 0;
  height: 24px;
  opacity: ${p => (p.isDark ? 0 : 1)};
  position: absolute;
  right: 0;
  top: 0;
  transform: translate(${p => (p.isDark ? `14px, -14px` : `0, 0`)});
  transition: background 0.25s ease, transform 0.45s ease;
  width: 24px;
`

const DarkModeToggle = ({ theme }) => {
  const themeToggle = useTheme()

  return (
    <IconWrapper
      isDark={theme.mode === "dark"}
      onClick={() => themeToggle.toggleDarkMode()}
      aria-label={
        theme.mode === "dark" ? "Switch to Light Mode" : "Switch to Dark Mode"
      }
      title={
        theme.mode === "dark" ? "Switch to Light Mode" : "Switch to Dark Mode"
      }
    >
      <MoonOrSun isDark={theme.mode === "dark"} />
      <MoonMask isDark={theme.mode === "dark"} />
    </IconWrapper>
  )
}

export default withTheme(DarkModeToggle)
